export const getInteractionsLogsUrl = (workspaceId: string, agentId: string) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/interactions`;

export const getInteractionLogUrl = (workspaceId: string, agentId: string, id: number) =>
  `/business/workspaces/${workspaceId}/agents/${agentId}/interactions/${id}`;
